import { React, models, kea, history } from "app/main/std";
import { DireccionClienteDTOList } from "./componentes/tabs/direcciones/list";
import { AuxiliarClienteForm } from "./componentes/tabs/auxiliarclienteform";
import { ClienteDescripcionPaqueteList } from "./componentes/tabs/descripcionpaquetes/list";
import { ClienteDeClienteList } from "./componentes/tabs/clientesfinales";
import { fa } from "typed-font-awesome";

type Entity = models.ClienteDTO;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGuardar: () => Promise<void>;
    editar: models.SeccionesCatalogoClientes;
    readonly?: boolean;
    nuevo: boolean;
}

/**
* Componente para editar un Entity
*/
export class ClienteForm extends React.PureComponent<Props> {

    render() {
        const { value, nuevo } = this.props;
        const tabs = nuevo ? [] : [
            {
                title: "Direcciones",
                iconClass: fa("address-card-o"),
                body: <DireccionClienteDTOList idCliente={value.IdRegistro} readonly={this.props.readonly || !this.props.editar.Direcciones} />,
                quitar: true
            },
            {
                title: "Clientes",
                iconClass: fa("handshake-o"),
                body: <ClienteDeClienteList idCliente={value.IdRegistro} readonly={this.props.readonly || !this.props.editar.ClientesRelacionados} />,
                quitar: true
            },
            {
                title: "Paquetes",
                iconClass: fa("cubes"),
                body: <ClienteDescripcionPaqueteList idCliente={value.IdRegistro} readonly={this.props.readonly || !this.props.editar.Paquetes} />,
                quitar: true
            }];

        return (
            <div>
                <kea.Title titulo="Editar cliente" onRegresar={() => window.history.back() } />
                <kea.Tab
                    items={[
                        {
                            title: "Datos generales",
                            iconClass: fa("user-circle-o"),
                            body: <AuxiliarClienteForm {...this.props} />
                        },
                        ...tabs
                    ]}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/edit/form.tsx